var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fb"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse 22",
    cx: 11.7349,
    cy: 11.4349,
    r: 10.72,
    stroke: "#EFEFF0",
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon zocial-facebook",
    d: "M9.38989 11.6064V9.7584H10.8805V8.82912C10.8805 8.15809 11.0979 7.58746 11.5334 7.11632C11.9689 6.64548 12.4966 6.40991 13.1156 6.40991H14.5963V8.25819H13.1156C13.0192 8.25819 12.9321 8.31141 12.8547 8.41785C12.7772 8.5243 12.7385 8.65494 12.7385 8.80977V9.7581H14.5963V11.6061H12.7382V16.0867H10.8802V11.6064H9.38989Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.64d2b61220816a48469c5bc86b7bf167.svg";
export { ForwardRef as ReactComponent };